import polyglotI18nProvider from "ra-i18n-polyglot";
import russianMessages from "ra-language-russian";

// Весь интерфейс react-admin (кнопки, пагинация, фильтры, подтверждения) — на русском.
export const i18nProvider = polyglotI18nProvider(
  () => russianMessages,
  "ru",
  [{ locale: "ru", name: "Русский" }],
);
